var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4479_538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6H6.5V1C6.5 0.867392 6.44732 0.740215 6.35355 0.646447C6.25979 0.552678 6.13261 0.5 6 0.5V0.5C5.86739 0.5 5.74021 0.552678 5.64645 0.646447C5.55268 0.740215 5.5 0.867392 5.5 1V6H0.5C0.367392 6 0.240215 6.05268 0.146447 6.14645C0.0526784 6.24021 0 6.36739 0 6.5H0C0 6.63261 0.0526784 6.75979 0.146447 6.85355C0.240215 6.94732 0.367392 7 0.5 7H5.5V12C5.5 12.1326 5.55268 12.2598 5.64645 12.3536C5.74021 12.4473 5.86739 12.5 6 12.5C6.13261 12.5 6.25979 12.4473 6.35355 12.3536C6.44732 12.2598 6.5 12.1326 6.5 12V7H11.5C11.6326 7 11.7598 6.94732 11.8536 6.85355C11.9473 6.75979 12 6.63261 12 6.5C12 6.36739 11.9473 6.24021 11.8536 6.14645C11.7598 6.05268 11.6326 6 11.5 6Z",
    fill: "#0090D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4479_538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.c7846773a899d6a5b099f03a8ab4b2e4.svg";
export { ForwardRef as ReactComponent };